import { SaleOrder } from '@/domain/SaleOrder';
import { Services } from '@/infra/services';

import { baseSaleOrderAdapter } from './adapter';

export async function getSaleOrderById(orderId: string) {
  const response = await Services.SaleOrder.getOrderById({ orderId });

  const domainProps = baseSaleOrderAdapter(response.data);

  return new SaleOrder(domainProps);
}
